import CompleteShopifyInstallPage from "./CompleteShopifyInstallPage";
export default CompleteShopifyInstallPage;
